import { useState } from "react";

/* AbhiGhar brand mark.
   Tries to load the PNG from /assets/abhighar-logo.png. If missing, falls
   back to an inline SVG that visually echoes the logo — navy buildings + a
   gold accent column + a window mark. The cream square behind it keeps the
   navy art visible on the dark navy sidebar. */
export function BrandMark() {
  const [failed, setFailed] = useState(false);
  return (
    <div className="w-8 h-8 rounded-lg bg-[#faf9f5] ring-1 ring-white/20 grid place-items-center shrink-0 overflow-hidden">
      {failed ? (
        <svg viewBox="0 0 32 32" className="w-6 h-6" aria-label="AbhiGhar">
          {/* Tall navy building */}
          <path d="M7 22 V11 L11 11 L11 22 Z" className="fill-[#162a52]" />
          {/* Gold accent column */}
          <path d="M13 22 V8 L16 8 L16 22 Z" className="fill-[#c79a3a]" />
          {/* House roof + body */}
          <path d="M18 22 V13 L22 10 L26 13 V22 Z" className="fill-[#162a52]" />
          {/* Gold window inside house */}
          <rect x="20.5" y="15.5" width="3.5" height="3.5" rx="0.5" className="fill-[#c79a3a]" />
          <line x1="22.25" y1="15.5" x2="22.25" y2="19" className="stroke-[#162a52]" strokeWidth="0.4" />
          <line x1="20.5" y1="17.25" x2="24" y2="17.25" className="stroke-[#162a52]" strokeWidth="0.4" />
        </svg>
      ) : (
        <img
          src="assets/abhighar-logo.png"
          alt="AbhiGhar"
          onError={() => setFailed(true)}
          className="w-6 h-6 object-contain"
        />
      )}
    </div>
  );
}
